import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const isValidPostLink = (url: string): boolean => {
  try {
    const parsed = new URL(url);
    return ['http:', 'https:'].includes(parsed.protocol);
  } catch {
    return false;
  }
};

export function urlValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || value.length === 0) return null;
    return isValidPostLink(value) ? null : { url: true };
  };
}
